<template>
  <el-card class="carnival-game">
    <div class="carnival-game__title">
      星动嘉年华
    </div>
    <div class="select-session-wrap">
      <RadioGroup v-model="chapterId" type="button" button-style="solid" :disabled="isEditing">
        <Radio :label="1">初级场</Radio>
        <Radio :label="2">中级场</Radio>
        <Radio :label="3">高级场</Radio>
        <Radio :label="901">邀请嘉年华</Radio>
      </RadioGroup>
    </div>
    <Collapse v-model="collapseValue">
      <Panel name="1">
        基础配置
        <template #content>
          <p style="margin:0 10px 10px;">{{ chapterId > 3 ? '当前普通用户奖池' : '当前游戏奖池' }}:{{ currentConfig.gameTotalPrice }}
            <span> </span> {{ chapterId > 3 ? '当前高净值用户奖池' : '当前幸运奖池' }}:{{ currentConfig.luckyTotalPrice }}
            <span v-if="chapterId === 901">低价值用户奖池:{{ currentConfig.trdTotalPrice }}</span></p>
          <div style="margin: 0 10px 10px; display: flex; justify-content: space-between; align-items: center;">
            <div></div>
            <div>
              <el-button v-if="!isEditing" type="primary" @click="startEdit">编辑配置</el-button>
              <template v-else>
                <el-button type="success" @click="saveConfig">保存</el-button>
                <el-button @click="cancelEdit">取消</el-button>
              </template>
            </div>
          </div>
          <CarnivalSearch v-model="currentConfig" @open="openDrawer" @refresh="refreshPage" :doc-id="chapterId"
            @save="saveConfig" :is-editing="isEditing">
          </CarnivalSearch>
        </template>
      </Panel>
      <Panel name="2">
        奖品列表
        <template #content>
          <CarnivalTable :table-list="currentConfig.rewardPoolList" :rs-list="resourceList" :doc-id="chapterId"
            @open="openDrawer">
          </CarnivalTable>
        </template>
      </Panel>
    </Collapse>
    <CarnivalDrawer v-model="drawerData.show" :config="currentConfig.rewardPoolList" @refresh="refreshPage"
      :doc-id="chapterId" :rs-list="resourceList" @save="saveConfig">
    </CarnivalDrawer>
  </el-card>
</template>

<script>
import CarnivalSearch from './CarnivalSearch.vue'
import CarnivalTable from './CarnivalTable.vue'
import CarnivalDrawer from './CarnivalDrawer.vue'
import { getCarnivalConfigReq, saveCarnivalConfigReq, getResourceListReq } from '@/api/carnivalApi.js'
export default {
  components: {
    CarnivalSearch, CarnivalTable, CarnivalDrawer
  },
  data() {
    return {
      collapseValue: ['1', '2'],
      chapterId: 1,
      docIdList: [],
      initData: [],
      tableList: [],
      isEditing: false, // 编辑状态
      originalChapterId: 1, // 保存编辑前的章节ID
      currentConfig: {
        docId: '',
        ticketId: '',
        upperLimit: 0,
        upperLimitRate: 0,
        lowLimit: 0,
        lowLimitRate: 0,
        luckyValue: 0,
        gameRate: 0,
        luckyRate: 0,
        systemRate: 0,
        expandValue: '',
        // 邀请嘉年华低价值用户配置
        trdUpperLimit: 0,
        trdUpperLimitRate: 0,
        trdLowLimit: 0,
        trdLowLimitRate: 0,
        trdRate: 0,
        lotteryFeesConfigList: [
          {
            lotteryCount: 0,
            lotteryPrice: 0
          },
          {
            lotteryCount: 0,
            lotteryPrice: 0
          }
        ],
        rewardPoolList: []
      },
      drawerData: {
        show: false,
        data: null,
        parentId: 0,
      },
      resourceList: []
    }
  },
  methods: {
    async getResourceList() {
      const res = await getResourceListReq()
      if (res.code === 0) {
        this.resourceList = res.data
      } else {
        this.$Message.error(res.msg)
      }
    },
    async saveConfig(data) {
      if (Array.isArray(data)) {
        this.currentConfig.rewardPoolList = data;
      }
      const res = await saveCarnivalConfigReq({ chapter: this.chapterId, ...this.currentConfig });
      if (res.code === 0) {
        this.$Message.success('保存成功')
        this.drawerData.show = false
        this.pageInit()
        // 保存成功后退出编辑状态并解锁
        await this.exitEditMode()
      } else {
        this.$Message.error(res.msg || res.message)
      }
    },
    openDrawer(isEdit, row) {
      this.drawerData.show = true
    },

    async pageInit() {
      this.currentConfig = this.$options.data().currentConfig;
      const res = await getCarnivalConfigReq(this.chapterId)
      if (res.code === 0) {
        console.log(res.data);
        if (res.data !== null) {
          this.currentConfig = res.data;
        } else {
          this.currentConfig = this.$options.data().currentConfig;
        }
        this.dataTranslate()
      } else {
        this.$Message.error(res.msg)
      }
    },

    dataTranslate() {
      let copyConfig = JSON.parse(JSON.stringify(this.currentConfig));
      // 高级场的情况
      if ((this.chapterId === 3 || this.chapterId === 901) && copyConfig.lotteryFeesConfigList.length) {
        copyConfig.lotteryFeesConfigList = copyConfig.lotteryFeesConfigList.concat(Array(Math.max(0, 3 - copyConfig.lotteryFeesConfigList.length)).fill({ lotteryPrice: 0, lotteryCount: 0 }))
      }
      // this.tableList = copyConfig.rewardPoolList;
      // this.tableList = this.tableList.map((item) => {
      //   if (item.rewardDetailList) {
      //     item.children = item.rewardDetailList
      //   }
      //   return item
      // });
      // delete copyConfig.rewardPoolList;
      this.currentConfig = copyConfig;
    },

    // 刷新页面，用于docId不变情况
    async refreshPage() {
      await this.pageInit(true)
    },

    // 开始编辑
    async startEdit() {
      try {
        // 保存当前章节ID
        this.originalChapterId = this.chapterId
        
        // 尝试锁定资源
        const lockSuccess = await this.$editLock.lock('resource_type_starry_config', this.chapterId, true)
        
        if (!lockSuccess) {
          this.$Message.error('当前配置正在被其他用户编辑，无法进入编辑模式')
          return
        }

        // 锁定成功后重新获取最新数据
        await this.pageInit()
        this.isEditing = true
        this.$Message.success('已进入编辑模式')
      } catch (error) {
        console.error('进入编辑模式失败:', error)
        this.$Message.error('进入编辑模式失败')
      }
    },

    // 取消编辑
    async cancelEdit() {
      try {
        // 解锁资源
        await this.$editLock.unlock('resource_type_starry_config', this.chapterId)
        
        // 恢复到原始章节
        this.chapterId = this.originalChapterId
        
        // 重新获取数据以恢复原始状态
        await this.pageInit()
        this.isEditing = false
        this.$Message.info('已取消编辑')
      } catch (error) {
        console.error('取消编辑失败:', error)
        this.$Message.error('取消编辑失败')
      }
    },

    // 退出编辑模式（保存成功后调用）
    async exitEditMode() {
      try {
        // 解锁资源
        await this.$editLock.unlock('resource_type_starry_config', this.chapterId)
        this.isEditing = false
      } catch (error) {
        console.error('退出编辑模式失败:', error)
      }
    }
  },
  watch: {
    chapterId(newVal) {
      // 编辑状态下不允许切换章节
      if (this.isEditing) {
        this.$Message.warning('编辑状态下不允许切换章节，请先保存或取消编辑')
        // 恢复原来的值
        this.$nextTick(() => {
          this.chapterId = this.originalChapterId
        })
        return
      }
      this.pageInit()
    }
  },
  mounted() {
    this.pageInit()
    this.getResourceList()
  }
}
</script>

<style scoped lang="scss">
.carnival-game {
  &__title {
    font-size: 20px;
    margin-bottom: 10px;
  }

  &__operate {
    margin: 10px 0;
    display: flex;
    gap: 8px;
  }
}

.select-session-wrap {
  margin-bottom: 10px;
}

.outer-table-wrap {
  height: calc(100vh - 300px);
}
</style>